import React, { ChangeEventHandler, FC, useEffect, useState } from 'react';
import { useController } from 'react-hook-form';
import FieldContainer from '@common/FieldContainer';
import { usePartnershipTermsList } from '@repository/partnership/usePartnership';
import { TERMS } from '@domain/constant/v1/termsType';
import { valueRequired } from '@utils/validators/validators';
import classnames from 'classnames/bind';
import styles from '../premium.module.scss';

const cx = classnames.bind(styles);

const TermsFrom: FC = () => {
  const { mutateAsync: fetchPartnershipTerms } = usePartnershipTermsList();

  const [privacyCollectionContent, setPrivacyCollectionContent] = useState('');
  const [privacyProvisionContent, setPrivacyProvisionContent] = useState('');

  const {
    field: { value: privacyCollectionYn, ...privacyCollectionField },
  } = useController({
    name: 'agreePrivacyCollectionYn', //개인정보 수집 및 이용 동의 (필수)
    defaultValue: false,
    rules: valueRequired,
  });

  const {
    field: { value: privacyProvisionYn, ...privacyProvisionField },
  } = useController({
    name: 'agreePrivacyProvisionYn', //개인정보 제3자 제공동의(선택)
    defaultValue: false,
    rules: valueRequired,
  });

  const isAllAgree = privacyCollectionYn && privacyProvisionYn;

  const onChangeAllAgree = () => {
    privacyCollectionField.onChange(!isAllAgree);
    privacyProvisionField.onChange(!isAllAgree);
  };

  const onChangePrivacyCollection: ChangeEventHandler<HTMLInputElement> = (e) => {
    privacyCollectionField.onChange(e.target.checked);
  };

  const onChangeThirdParty: ChangeEventHandler<HTMLInputElement> = (e) => {
    privacyProvisionField.onChange(e.target.checked);
  };

  const onInit = async () => {
    const termsData = await Promise.all([
      await fetchPartnershipTerms(TERMS.PRIVACY_COLLECTION),
      await fetchPartnershipTerms(TERMS.PRIVACY_PROVISION),
    ]);

    setPrivacyCollectionContent(termsData[0]?.terms.contents || '');
    setPrivacyProvisionContent(termsData[1]?.terms.contents || '');
  };

  useEffect(() => {
    onInit();
  }, []);

  return (
    <FieldContainer premiumName={true} name={<>신청 동의</>} required={true}>
      <div className={cx('termsArea')}>
        <div className={cx('allAgreeWrap')}>
          <label className={cx('label')}>
            <input type="checkbox" checked={isAllAgree} className={cx('input', 'hidden')} onChange={onChangeAllAgree} />
            <span className={cx('checkbox')} />
            개인정보 수집 및 이용, 제3자 제공에 모두 동의합니다.
          </label>
        </div>

        <ul className={cx('termsList')}>
          <li className={cx('termsItem')}>
            <div className={cx('labelWrap')}>
              <label className={cx('label')}>
                <input
                  {...privacyCollectionField}
                  type="checkbox"
                  className={cx('input', 'hidden')}
                  checked={privacyCollectionYn}
                  onChange={onChangePrivacyCollection}
                />
                <span className={cx('checkbox')} />
                개인정보 수집 및 이용동의(필수)
              </label>
            </div>
            <div className={cx('agreementTextArea')}>
              <div className={cx('agreementTextWrap')}>
                <div
                  className={cx('agreementText')}
                  dangerouslySetInnerHTML={{
                    __html: privacyCollectionContent,
                  }}
                />
              </div>
            </div>
          </li>
          <li className={cx('termsItem')}>
            <div className={cx('labelWrap')}>
              <label className={cx('label')}>
                <input
                  {...privacyProvisionField}
                  type="checkbox"
                  className={cx('input', 'hidden')}
                  checked={privacyProvisionYn}
                  onChange={onChangeThirdParty}
                />
                <span className={cx('checkbox')} />
                개인정보 제3자 제공동의(필수)
              </label>
            </div>
            <div className={cx('agreementTextArea')}>
              <div className={cx('agreementTextWrap')}>
                <div
                  className={cx('agreementText')}
                  dangerouslySetInnerHTML={{
                    __html: privacyProvisionContent,
                  }}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </FieldContainer>
  );
};

export default TermsFrom;
